import { useEffect } from 'react'

import Product from '@src/quince-site-common/src/domains/Product'
import { ProductVariantOption } from '@src/quince-site-common/src/domains/ProductVariant'
import productHelper from '@src/quince-site-common/src/helpers/productHelper'
import pdpStateManager from '@src/quince-site-common/src/redux/globalStateManager/PDPStateManager'
import { getFestivalOfferPrice } from '@src/quince-site-common/src/utils/festivalOffersUtility'
import { TPDPSectionData } from '@src/quince-site-pdp/src/types/pdp-section-data.type'

import MiniPDPProductCTA from '../miniPDPProductCTA/miniPDPProductCTA'
import { MiniPDPProductInfo } from '../miniPDPProductInfo/miniPDPProductInfo'

import styles from './miniPDPProductPurchase.module.scss'
import { useMiniPDPProductTracker } from './useMiniPDPProductTracker'

export const MiniPDPProductPurchase = ({
  product,
  sectionData,
  selectedOptions,
}: {
  product: Product
  sectionData: TPDPSectionData
  selectedOptions: ProductVariantOption[]
}) => {
  const selectedVariant = productHelper.getVariantWithMinQuincePriceForOptions(product, selectedOptions)

  useMiniPDPProductTracker({ product, selectedOptions, selectedVariant, sectionData })

  useEffect(() => {
    pdpStateManager.setSelectedOptions({
      slug: product.slug,
      spid: Number(product.spid),
      selectedOptions: selectedOptions.map(so => ({ name: so.name, value: so.value })),
      productId: product.id.toString(),
      productTitle: product.title,
    })
    const salePrice = productHelper.getQuincePriceForOptions(product, selectedOptions)
    const festivalOfferPrice =
      getFestivalOfferPrice({
        product: product,
        selectedOptions,
      }) ?? undefined
    pdpStateManager.setSeoPrice({
      seoPrice: festivalOfferPrice ?? salePrice,
    })
  }, [selectedOptions])

  return (
    <div className={styles.wrapper}>
      <MiniPDPProductInfo product={product} selectedOptions={selectedOptions} selectedVariant={selectedVariant} />
      <MiniPDPProductCTA product={product} selectedOptions={selectedOptions} productOptions={product.productOptions} />
    </div>
  )
}
